import "./stack.css.ts.vanilla.js";
var r = "xjgm6d2", m = "xjgm6d1", v = {
    space: "var(--xjgm6d0)"
};
export { r as flexStack, m as marginStack, v as vars };
